import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons";
import "./../../UaeAttestation/UaeService/UaeService.css";
const GermanyServiceMain = () => {
  return (
    <div className="uaeServiceMainContainer">
      <ul>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>{" "}
          Document legalization is the procedure of procuring the MEA sticker on
          the document. It is a part of the legalization of the required
          certificate authentication that indicates the genuinity of your
          documents & your intent of visiting Germany. Apostille documents in
          India are issued by the Ministry of External Affairs which is the
          department of the Indian government that deals with foreign affairs.
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>
          {"  "}
          You can get the Germany Apostille services in Bangalore at Goodway
          attestation which is approved by Ministries & embassies in India as
          well as abroad. We provide you best quality services & will complete
          the entire procedure of your document attestation.
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>{" "}
          An apostille issued in Germany is a simpler legalization procedure
          that certifies the authenticity of a signature or seal on a document
          issued in Germany and intended for use in any foreign country that has
          signed the Hague Convention.
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>{" "}
          It's important to note that the German apostille only certifies the
          authenticity of the signature or seal on the document, not the content
          of the document. Goodway attestation is one of the best agencies that
          provide Germany apostille service in Bangalore. It has been approved
          by Indian and foreign ministries and embassies.
        </li>
      </ul>
    </div>
  );
};

export default GermanyServiceMain;
